import React from "react";
import { inject } from "mobx-react";
import {
  Button,
  Row,
  Col,
  FormGroup
} from "reactstrap";

import ImportationsComponent from "./ImportationsComponent";
import LoadingComponent from "~/components/LoadingComponent";
import AlertComponent from "~/components/AlertComponent";
import { USER_LEVEL } from "../../configs/constants";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { autoCompleteSx } from '../../helpers/utils'
import PaginationComponent from "~/components/PaginationComponent";

@inject("WsStore", "ProductStore", "UserStore", "OrganizationStore", "FileStore")
class ImportationsContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      files: [],
      selectedFile: null
    };

    this.refreshInterval = null;
  }

  async componentDidMount() {
    await this.getFiles();

    this.refreshInterval = setInterval(() => {
      this.goRefresh();
    }, 15000);
  }

  componentWillUnmount() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }

  onOpenFileDialog = () => {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }
    this.fileDialogOpened = true;
    window.addEventListener("focus", this.onFileDialogClose, { once: true });
  };

  onFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      this.setState({ selectedFile: file });
    }
    event.target.value = "";
    this.fileDialogOpened = false;
    this.startRefresh();
  };

  onFileDialogClose = () => {
    this.fileDialogOpened = false;
    this.startRefresh();
  };

  startRefresh = () => {
    if (!this.refreshInterval) {
      this.refreshInterval = setInterval(() => {
        this.goRefresh();
      }, 15000);
    }
  };

  getFiles = async (organization, organizationName, skip) => {
    this.setState({ isLoading: true });
    if (skip === undefined) skip = 0; 
    const { FileStore } = this.props;
    let { organizations } = this.state;
    if (organization === undefined) {
      organizations = await this.getOrganizations(organizationName);
      organization = organizations[0];
    }  
    
    const data = await FileStore.getByOrganizationId(organization.organizationId, skip);
    let files = [], countItems = 0, currentPage = 1, countPages = 1;
    if (data && data !== "" && data.files.length > 0) {
      files = data.files;
      countItems = data.countItems;
      countPages = data.countPages;
    }  
    this.setState({
      organization, organizations, files,
      currentPage, countItems, countPages,
      skip, isLoading: false
    });
  };

  getOrganizations = async (value) => {
    const { OrganizationStore } = this.props;
    let organizationsData = await OrganizationStore.getOrganizations(value);
    return organizationsData.organizations;
  };

  onReceivedAgent = async () => {
    const { organization, skip } = this.state;
    this.setState({ isLoading: true });

    const { WsStore } = this.props;
    const isOk = await WsStore.send();
    isOk
      ? AlertComponent.success("Integração notificada com sucesso")
      : AlertComponent.error("Falha ao notificar a integração");

    this.setState({ isLoading: false });
    await this.getFiles(organization, organization.name, skip);
  };

  onFileUpload = async () => {
    const { selectedFile, organization, skip } = this.state;
    if (!selectedFile) return AlertComponent.error("Nenhum arquivo selecionado");
    if (!organization || organization.organizationId === 0)
      return AlertComponent.error("Estabelecimento inválido");

    this.setState({ isLoading: true });

    const formData = new FormData();
    formData.append(selectedFile.name, selectedFile);
    const { ProductStore } = this.props;
    const uploadIsOk = await ProductStore.uploadFile(formData, organization.organizationId);

    uploadIsOk
      ? AlertComponent.success("Arquivo enviado para processamento")
      : AlertComponent.error("Falha ao importar arquivo");

    this.setState({ isLoading: false, selectedFile: null });
    await this.getFiles(organization, organization.name, skip);
  };

  onKeyUpOrganization = async (value) => {
    try {
      let organizations = await this.getOrganizations(value);
      this.setState({ organizations });
    } catch {}
  };

  onChangeOrganization = async (organizationName) => {
    let { organizations, organization } = this.state;
    for(let i = 0; i < organizations.length; i++){
      if (organizations[i].name === organizationName){
        organization = organizations[i];
        break;
      }
    }
    this.setState({ organization });
    await this.getFiles(organization, organization.name);
  };
  
  goRefresh = async () => {
    const { organization, skip } = this.state;
    await this.getFiles(organization, organization.name, skip);
  };
  
  onPageChange = async (currentPage) => {  
    this.setState({ isLoading: true });  
    const skip = (currentPage - 1) * 100;
    const { organization } = this.state;
    await this.getFiles(organization, organization.name, skip);
    this.setState({ currentPage, skip, isLoading: false });
  };

  render() {
    const { isLoading, files, organization, organizations, currentPage, countItems } = this.state;
    const { UserStore } = this.props;
    return (
      <>
        {isLoading ? (
          <LoadingComponent />
        ) : (
          <div className="content content-xs">
            <Row>
              {UserStore.getLevel() === USER_LEVEL.manager && (
                <Col xs={12} md={12}>
                  <FormGroup>
                    <label style={{marginBottom: "0px"}}>Estabelecimento:</label>
                    <Autocomplete
                      freeSolo
                      noOptionsText={"Nenhum item"}                      
                      onChange={(event, value) => this.onChangeOrganization(value)}
                      style={{paddingBottom: "10px"}}                                      
                      value={organization?.name}
                      id="organization"
                      options={organizations.map((o) => o.name)}
                      isOptionEqualToValue={(option, value) => option.organizationId === value.organizationId}
                      size="small"
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="standard"
                          onInput={(e) => this.onKeyUpOrganization(e.target.value)}
                        />
                      )}
                      sx={autoCompleteSx()}
                      renderOption={(props, option) => (
                        <span {...props}>{option}</span>
                      )}                      
                    />
                  </FormGroup>
                </Col>
              )} 
              <Col xs={12} md={3}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                <label htmlFor="file-upload" className="btn btn-secondary btn-xs">
                  Selecionar arquivo
                </label>

                <input
                  id="file-upload"
                  type="file"
                  onClick={this.onOpenFileDialog}
                  onChange={this.onFileChange}
                  style={{ display: "none" }}
                />

                <span style={{ marginTop: "5px" }}>
                  {this.state.selectedFile
                    ? this.state.selectedFile.name
                    : "Nenhum arquivo selecionado"}
                </span>
              </div>
              </Col>
              <Col xs={12} md={3}>
                <Button 
                  style={{marginLeft: "10px"}}
                  className="btn-fill btn-xs btn-xs-0"
                  color="secondary"
                  onClick={this.onFileUpload}>
                  Enviar arquivo
                </Button> 
              </Col>
              <Col xs={12} md={3}>
                <Button 
                  style={{marginLeft: "10px"}}
                  className="btn-fill btn-xs btn-xs-0"
                  color="secondary"
                  onClick={this.onReceivedAgent}>
                  Receber da integração
                </Button>
              </Col>   
                           
              <Col xs={12} md={3} style={{textAlign: "right"}}>                
                <Button
                  className="btn-fill btn-xs"
                  color="primary"
                  type="submit"
                  onClick={this.goRefresh}
                >
                  Atualizar 
                </Button>                  
              </Col>                
            </Row>
            <Row>
              <Col xs={8} md={8}></Col>
              <Col xs={4} md={4} style={{textAlign: "right"}}>
                <span>
                  Atualizado em: {new Date().toLocaleString()}
                </span>
              </Col>
            </Row>
            <br/>
            <Row>
              <Col xs={2} md={2}>Início</Col>
              <Col xs={2} md={2}>Atualização</Col>
              <Col xs={4} md={4}>Estabelecimento</Col>
              <Col xs={2} md={2}>Status</Col>
              <Col xs={2} md={2}>Quantidade</Col>
            </Row>  
            {files && (
              <ImportationsComponent files={files} />
            )}
            <PaginationComponent
              className="pagination-bar"
              currentPage={currentPage}
              totalCount={countItems}
              onPageChange={this.onPageChange}
            />
          </div>
        )}
      </>
    );
  }
}

export default ImportationsContainer;
